export default __webpack_public_path__ + "1d4909fb4735ebaac5dbee682127622d.png";